import PropTypes from "prop-types";

import { TableCell, TableRow } from "@mui/material";
import StatusChip from "src/components/StatusChip";

// ----------------------------------------------------------------------

EnrollmentTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
  onEditRow: PropTypes.func,
  onDeleteRow: PropTypes.func,
  onViewRow: PropTypes.func,
};

export default function EnrollmentTableRow({ row, selected }) {
  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell align="left">{row.enrollment_number ?? "-"}</TableCell>
        <TableCell align="left" sx={{ maxWidth: 350 }}>
          {row.program_name ?? "-"}
        </TableCell>
        <TableCell align="left">{row.date_of_enrollment ?? "-"}</TableCell>
        <TableCell align="left">
          <ul>
            {row?.teachers?.map((teacher, index) => (
              <>
                <li key={index}>{teacher}</li>
              </>
            ))}
          </ul>
        </TableCell>

        <TableCell align="left">{row.total_classes ?? "-"}</TableCell>
        <TableCell align="left">{row.no_of_classes_attended ?? "-"}</TableCell>
        <TableCell align="left">{row.no_of_classes_left ?? "-"}</TableCell>

        <TableCell align="left">
          <StatusChip status={row.status ?? "-"} />
        </TableCell>
      </TableRow>
    </>
  );
}
